import { useTeamSetupAreaContextRequired } from './TeamSetupAreaContext';
import { SettingsBreadcrumbs } from '../settingsModule';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import React from 'react';

export  function MarketPageBreadcrumbs() {
  const context = useTeamSetupAreaContextRequired();

  return (
    <SettingsBreadcrumbs>
      <Breadcrumb text="Markets & Processes" href="/settings/markets">
        <Breadcrumb
          text={context.teamSetupArea.name}
          href={`/settings/markets/${context.teamSetupArea.id}`}
        />
      </Breadcrumb>
    </SettingsBreadcrumbs>
  );

}
